export type TCountryCode = {
  phoneCode: string;
  countryCode: string;
  country: string;
};

export const countryCodes: TCountryCode[] = [
  {
    phoneCode: '1',
    countryCode: 'AG',
    country: 'Антигуа и Барбуда'
  },
  {
    phoneCode: '1',
    countryCode: 'AI',
    country: 'Ангилья'
  },
  {
    phoneCode: '1',
    countryCode: 'AS',
    country: 'Американское Самоа'
  },
  {
    phoneCode: '1',
    countryCode: 'BB',
    country: 'Барбадос'
  },
  {
    phoneCode: '1',
    countryCode: 'BM',
    country: 'Бермуды'
  },
  {
    phoneCode: '1',
    countryCode: 'BS',
    country: 'Багамы'
  },
  {
    phoneCode: '1',
    countryCode: 'CA',
    country: 'Канада'
  },
  {
    phoneCode: '1',
    countryCode: 'DM',
    country: 'Доминика'
  },
  {
    phoneCode: '1',
    countryCode: 'DO',
    country: 'Доминиканская Республика'
  },
  {
    phoneCode: '1',
    countryCode: 'GD',
    country: 'Гренада'
  },
  {
    phoneCode: '1',
    countryCode: 'GU',
    country: 'Гуам'
  },
  {
    phoneCode: '1',
    countryCode: 'JM',
    country: 'Ямайка'
  },
  {
    phoneCode: '1',
    countryCode: 'KN',
    country: 'Сент-Китс и Невис'
  },
  {
    phoneCode: '1',
    countryCode: 'KY',
    country: 'Каймановы Острова'
  },
  {
    phoneCode: '1',
    countryCode: 'LC',
    country: 'Сент-Люсия'
  },
  {
    phoneCode: '1',
    countryCode: 'MP',
    country: 'Северные Марианские Острова'
  },
  {
    phoneCode: '1',
    countryCode: 'MS',
    country: 'Монтсеррат'
  },
  {
    phoneCode: '1',
    countryCode: 'PR',
    country: 'Пуэрто-Рико'
  },
  {
    phoneCode: '1',
    countryCode: 'SX',
    country: 'Синт-Мартен (нидерландская часть)'
  },
  {
    phoneCode: '1',
    countryCode: 'TC',
    country: 'Тёркс и Кайкос'
  },
  {
    phoneCode: '1',
    countryCode: 'TT',
    country: 'Тринидад и Тобаго'
  },
  {
    phoneCode: '1',
    countryCode: 'US',
    country: 'Соединённые Штаты'
  },
  {
    phoneCode: '1',
    countryCode: 'VC',
    country: 'Сент-Винсент и Гренадины'
  },
  {
    phoneCode: '1',
    countryCode: 'VG',
    country: 'Виргинские Острова (Великобритания)'
  },
  {
    phoneCode: '1',
    countryCode: 'VI',
    country: 'Виргинские Острова (США)'
  },
  {
    phoneCode: '20',
    countryCode: 'EG',
    country: 'Египет'
  },
  {
    phoneCode: '211',
    countryCode: 'SS',
    country: 'Южный Судан'
  },
  {
    phoneCode: '212',
    countryCode: 'EH',
    country: 'Западная Сахара'
  },
  {
    phoneCode: '212',
    countryCode: 'MA',
    country: 'Марокко'
  },
  {
    phoneCode: '213',
    countryCode: 'DZ',
    country: 'Алжир'
  },
  {
    phoneCode: '216',
    countryCode: 'TN',
    country: 'Тунис'
  },
  {
    phoneCode: '218',
    countryCode: 'LY',
    country: 'Ливия'
  },
  {
    phoneCode: '220',
    countryCode: 'GM',
    country: 'Гамбия'
  },
  {
    phoneCode: '221',
    countryCode: 'SN',
    country: 'Сенегал'
  },
  {
    phoneCode: '222',
    countryCode: 'MR',
    country: 'Мавритания'
  },
  {
    phoneCode: '223',
    countryCode: 'ML',
    country: 'Мали'
  },
  {
    phoneCode: '224',
    countryCode: 'GN',
    country: 'Гвинея'
  },
  {
    phoneCode: '225',
    countryCode: 'CI',
    country: 'Кот-д\'Ивуар'
  },
  {
    phoneCode: '226',
    countryCode: 'BF',
    country: 'Буркина-Фасо'
  },
  {
    phoneCode: '227',
    countryCode: 'NE',
    country: 'Нигер'
  },
  {
    phoneCode: '228',
    countryCode: 'TG',
    country: 'Того'
  },
  {
    phoneCode: '229',
    countryCode: 'BJ',
    country: 'Бенин'
  },
  {
    phoneCode: '230',
    countryCode: 'MU',
    country: 'Маврикий'
  },
  {
    phoneCode: '231',
    countryCode: 'LR',
    country: 'Либерия'
  },
  {
    phoneCode: '232',
    countryCode: 'SL',
    country: 'Сьерра-Леоне'
  },
  {
    phoneCode: '233',
    countryCode: 'GH',
    country: 'Гана'
  },
  {
    phoneCode: '234',
    countryCode: 'NG',
    country: 'Нигерия'
  },
  {
    phoneCode: '235',
    countryCode: 'TD',
    country: 'Чад'
  },
  {
    phoneCode: '236',
    countryCode: 'CF',
    country: 'Центральноафриканская Республика'
  },
  {
    phoneCode: '237',
    countryCode: 'CM',
    country: 'Камерун'
  },
  {
    phoneCode: '238',
    countryCode: 'CV',
    country: 'Кабо-Верде'
  },
  {
    phoneCode: '239',
    countryCode: 'ST',
    country: 'Сан-Томе и Принсипи'
  },
  {
    phoneCode: '240',
    countryCode: 'GQ',
    country: 'Экваториальная Гвинея'
  },
  {
    phoneCode: '241',
    countryCode: 'GA',
    country: 'Габон'
  },
  {
    phoneCode: '242',
    countryCode: 'CG',
    country: 'Конго'
  },
  {
    phoneCode: '243',
    countryCode: 'CD',
    country: 'Конго, Демократическая Республика'
  },
  {
    phoneCode: '244',
    countryCode: 'AO',
    country: 'Ангола'
  },
  {
    phoneCode: '245',
    countryCode: 'GW',
    country: 'Гвинея-Бисау'
  },
  {
    phoneCode: '246',
    countryCode: 'IO',
    country: 'Британская территория в Индийском океане'
  },
  // {
  //   phoneCode: '247',
  //   countryCode: 'AC'
  // },
  {
    phoneCode: '248',
    countryCode: 'SC',
    country: 'Сейшелы'
  },
  {
    phoneCode: '249',
    countryCode: 'SD',
    country: 'Судан'
  },
  {
    phoneCode: '250',
    countryCode: 'RW',
    country: 'Руанда'
  },
  {
    phoneCode: '251',
    countryCode: 'ET',
    country: 'Эфиопия'
  },
  {
    phoneCode: '252',
    countryCode: 'SO',
    country: 'Сомали'
  },
  {
    phoneCode: '253',
    countryCode: 'DJ',
    country: 'Джибути'
  },
  {
    phoneCode: '254',
    countryCode: 'KE',
    country: 'Кения'
  },
  {
    phoneCode: '255',
    countryCode: 'TZ',
    country: 'Танзания'
  },
  {
    phoneCode: '256',
    countryCode: 'UG',
    country: 'Уганда'
  },
  {
    phoneCode: '257',
    countryCode: 'BI',
    country: 'Бурунди'
  },
  {
    phoneCode: '258',
    countryCode: 'MZ',
    country: 'Мозамбик'
  },
  {
    phoneCode: '260',
    countryCode: 'ZM',
    country: 'Замбия'
  },
  {
    phoneCode: '261',
    countryCode: 'MG',
    country: 'Мадагаскар'
  },
  {
    phoneCode: '262',
    countryCode: 'RE',
    country: 'Реюньон'
  },
  {
    phoneCode: '262',
    countryCode: 'YT',
    country: 'Майотта'
  },
  {
    phoneCode: '263',
    countryCode: 'ZW',
    country: 'Зимбабве'
  },
  {
    phoneCode: '264',
    countryCode: 'NA',
    country: 'Намибия'
  },
  {
    phoneCode: '265',
    countryCode: 'MW',
    country: 'Малави'
  },
  {
    phoneCode: '266',
    countryCode: 'LS',
    country: 'Лесото'
  },
  {
    phoneCode: '267',
    countryCode: 'BW',
    country: 'Ботсвана'
  },
  {
    phoneCode: '268',
    countryCode: 'SZ',
    country: 'Эсватини'
  },
  {
    phoneCode: '269',
    countryCode: 'KM',
    country: 'Коморы'
  },
  {
    phoneCode: '27',
    countryCode: 'ZA',
    country: 'Южная Африка'
  },
  {
    phoneCode: '290',
    countryCode: 'SH',
    country: 'Острова Святой Елены, Вознесения и Тристан-да-Кунья'
  },
  // {
  //   phoneCode: '290',
  //   countryCode: 'TA'
  // },
  {
    phoneCode: '291',
    countryCode: 'ER',
    country: 'Эритрея'
  },
  {
    phoneCode: '297',
    countryCode: 'AW',
    country: 'Аруба'
  },
  {
    phoneCode: '298',
    countryCode: 'FO',
    country: 'Фарерские острова'
  },
  {
    phoneCode: '299',
    countryCode: 'GL',
    country: 'Гренландия'
  },
  {
    phoneCode: '30',
    countryCode: 'GR',
    country: 'Греция'
  },
  {
    phoneCode: '31',
    countryCode: 'NL',
    country: 'Нидерланды'
  },
  {
    phoneCode: '32',
    countryCode: 'BE',
    country: 'Бельгия'
  },
  {
    phoneCode: '33',
    countryCode: 'FR',
    country: 'Франция'
  },
  {
    phoneCode: '34',
    countryCode: 'ES',
    country: 'Испания'
  },
  {
    phoneCode: '350',
    countryCode: 'GI',
    country: 'Гибралтар'
  },
  {
    phoneCode: '351',
    countryCode: 'PT',
    country: 'Португалия'
  },
  {
    phoneCode: '352',
    countryCode: 'LU',
    country: 'Люксембург'
  },
  {
    phoneCode: '353',
    countryCode: 'IE',
    country: 'Ирландия'
  },
  {
    phoneCode: '354',
    countryCode: 'IS',
    country: 'Исландия'
  },
  {
    phoneCode: '355',
    countryCode: 'AL',
    country: 'Албания'
  },
  {
    phoneCode: '356',
    countryCode: 'MT',
    country: 'Мальта'
  },
  {
    phoneCode: '357',
    countryCode: 'CY',
    country: 'Кипр'
  },
  {
    phoneCode: '358',
    countryCode: 'AX',
    country: 'Аландские острова'
  },
  {
    phoneCode: '358',
    countryCode: 'FI',
    country: 'Финляндия'
  },
  {
    phoneCode: '359',
    countryCode: 'BG',
    country: 'Болгария'
  },
  {
    phoneCode: '36',
    countryCode: 'HU',
    country: 'Венгрия'
  },
  {
    phoneCode: '370',
    countryCode: 'LT',
    country: 'Литва'
  },
  {
    phoneCode: '371',
    countryCode: 'LV',
    country: 'Латвия'
  },
  {
    phoneCode: '372',
    countryCode: 'EE',
    country: 'Эстония'
  },
  {
    phoneCode: '373',
    countryCode: 'MD',
    country: 'Молдова'
  },
  {
    phoneCode: '374',
    countryCode: 'AM',
    country: 'Армения'
  },
  {
    phoneCode: '375',
    countryCode: 'BY',
    country: 'Беларусь'
  },
  {
    phoneCode: '376',
    countryCode: 'AD',
    country: 'Андорра'
  },
  {
    phoneCode: '377',
    countryCode: 'MC',
    country: 'Монако'
  },
  {
    phoneCode: '378',
    countryCode: 'SM',
    country: 'Сан-Марино'
  },
  {
    phoneCode: '380',
    countryCode: 'UA',
    country: 'Украина'
  },
  {
    phoneCode: '381',
    countryCode: 'RS',
    country: 'Сербия'
  },
  {
    phoneCode: '382',
    countryCode: 'ME',
    country: 'Черногория'
  },
  // {
  //   phoneCode: '383',
  //   countryCode: 'XK'
  // },
  {
    phoneCode: '385',
    countryCode: 'HR',
    country: 'Хорватия'
  },
  {
    phoneCode: '386',
    countryCode: 'SI',
    country: 'Словения'
  },
  {
    phoneCode: '387',
    countryCode: 'BA',
    country: 'Босния и Герцеговина'
  },
  {
    phoneCode: '389',
    countryCode: 'MK',
    country: 'Северная Македония'
  },
  {
    phoneCode: '39',
    countryCode: 'IT',
    country: 'Италия'
  },
  {
    phoneCode: '39',
    countryCode: 'VA',
    country: 'Ватикан'
  },
  {
    phoneCode: '40',
    countryCode: 'RO',
    country: 'Румыния'
  },
  {
    phoneCode: '41',
    countryCode: 'CH',
    country: 'Швейцария'
  },
  {
    phoneCode: '420',
    countryCode: 'CZ',
    country: 'Чехия'
  },
  {
    phoneCode: '421',
    countryCode: 'SK',
    country: 'Словакия'
  },
  {
    phoneCode: '423',
    countryCode: 'LI',
    country: 'Лихтенштейн'
  },
  {
    phoneCode: '43',
    countryCode: 'AT',
    country: 'Австрия'
  },
  {
    phoneCode: '44',
    countryCode: 'GB',
    country: 'Великобритания'
  },
  {
    phoneCode: '44',
    countryCode: 'GG',
    country: 'Гернси'
  },
  {
    phoneCode: '44',
    countryCode: 'IM',
    country: 'Остров Мэн'
  },
  {
    phoneCode: '44',
    countryCode: 'JE',
    country: 'Джерси'
  },
  {
    phoneCode: '45',
    countryCode: 'DK',
    country: 'Дания'
  },
  {
    phoneCode: '46',
    countryCode: 'SE',
    country: 'Швеция'
  },
  {
    phoneCode: '47',
    countryCode: 'NO',
    country: 'Норвегия'
  },
  {
    phoneCode: '47',
    countryCode: 'SJ',
    country: 'Шпицберген и Ян-Майен'
  },
  {
    phoneCode: '48',
    countryCode: 'PL',
    country: 'Польша'
  },
  {
    phoneCode: '49',
    countryCode: 'DE',
    country: 'Германия'
  },
  {
    phoneCode: '500',
    countryCode: 'FK',
    country: 'Фолклендские острова'
  },
  {
    phoneCode: '501',
    countryCode: 'BZ',
    country: 'Белиз'
  },
  {
    phoneCode: '502',
    countryCode: 'GT',
    country: 'Гватемала'
  },
  {
    phoneCode: '503',
    countryCode: 'SV',
    country: 'Сальвадор'
  },
  {
    phoneCode: '504',
    countryCode: 'HN',
    country: 'Гондурас'
  },
  {
    phoneCode: '505',
    countryCode: 'NI',
    country: 'Никарагуа'
  },
  {
    phoneCode: '506',
    countryCode: 'CR',
    country: 'Коста-Рика'
  },
  {
    phoneCode: '507',
    countryCode: 'PA',
    country: 'Панама'
  },
  {
    phoneCode: '508',
    countryCode: 'PM',
    country: 'Сен-Пьер и Микелон'
  },
  {
    phoneCode: '509',
    countryCode: 'HT',
    country: 'Гаити'
  },
  {
    phoneCode: '51',
    countryCode: 'PE',
    country: 'Перу'
  },
  {
    phoneCode: '52',
    countryCode: 'MX',
    country: 'Мексика'
  },
  {
    phoneCode: '53',
    countryCode: 'CU',
    country: 'Куба'
  },
  {
    phoneCode: '54',
    countryCode: 'AR',
    country: 'Аргентина'
  },
  {
    phoneCode: '55',
    countryCode: 'BR',
    country: 'Бразилия'
  },
  {
    phoneCode: '56',
    countryCode: 'CL',
    country: 'Чили'
  },
  {
    phoneCode: '57',
    countryCode: 'CO',
    country: 'Колумбия'
  },
  {
    phoneCode: '58',
    countryCode: 'VE',
    country: 'Венесуэла'
  },
  {
    phoneCode: '590',
    countryCode: 'BL',
    country: 'Сен-Бартелеми'
  },
  {
    phoneCode: '590',
    countryCode: 'GP',
    country: 'Гваделупа'
  },
  {
    phoneCode: '590',
    countryCode: 'MF',
    country: 'Сен-Мартен (французская часть)'
  },
  {
    phoneCode: '591',
    countryCode: 'BO',
    country: 'Боливия'
  },
  {
    phoneCode: '592',
    countryCode: 'GY',
    country: 'Гайана'
  },
  {
    phoneCode: '593',
    countryCode: 'EC',
    country: 'Эквадор'
  },
  {
    phoneCode: '594',
    countryCode: 'GF',
    country: 'Французская Гвиана'
  },
  {
    phoneCode: '595',
    countryCode: 'PY',
    country: 'Парагвай'
  },
  {
    phoneCode: '596',
    countryCode: 'MQ',
    country: 'Мартиника'
  },
  {
    phoneCode: '597',
    countryCode: 'SR',
    country: 'Суринам'
  },
  {
    phoneCode: '598',
    countryCode: 'UY',
    country: 'Уругвай'
  },
  {
    phoneCode: '599',
    countryCode: 'BQ',
    country: 'Бонайре, Синт-Эстатиус и Саба'
  },
  {
    phoneCode: '599',
    countryCode: 'CW',
    country: 'Кюрасао'
  },
  {
    phoneCode: '60',
    countryCode: 'MY',
    country: 'Малайзия'
  },
  {
    phoneCode: '61',
    countryCode: 'AU',
    country: 'Австралия'
  },
  {
    phoneCode: '61',
    countryCode: 'CC',
    country: 'Кокосовые острова'
  },
  {
    phoneCode: '61',
    countryCode: 'CX',
    country: 'Остров Рождества'
  },
  {
    phoneCode: '62',
    countryCode: 'ID',
    country: 'Индонезия'
  },
  {
    phoneCode: '63',
    countryCode: 'PH',
    country: 'Филиппины'
  },
  {
    phoneCode: '64',
    countryCode: 'NZ',
    country: 'Новая Зеландия'
  },
  {
    phoneCode: '65',
    countryCode: 'SG',
    country: 'Сингапур'
  },
  {
    phoneCode: '66',
    countryCode: 'TH',
    country: 'Таиланд'
  },
  {
    phoneCode: '670',
    countryCode: 'TL',
    country: 'Восточный Тимор'
  },
  {
    phoneCode: '672',
    countryCode: 'NF',
    country: 'Остров Норфолк'
  },
  {
    phoneCode: '673',
    countryCode: 'BN',
    country: 'Бруней'
  },
  {
    phoneCode: '674',
    countryCode: 'NR',
    country: 'Науру'
  },
  {
    phoneCode: '675',
    countryCode: 'PG',
    country: 'Папуа — Новая Гвинея'
  },
  {
    phoneCode: '676',
    countryCode: 'TO',
    country: 'Тонга'
  },
  {
    phoneCode: '677',
    countryCode: 'SB',
    country: 'Соломоновы Острова'
  },
  {
    phoneCode: '678',
    countryCode: 'VU',
    country: 'Вануату'
  },
  {
    phoneCode: '679',
    countryCode: 'FJ',
    country: 'Фиджи'
  },
  {
    phoneCode: '680',
    countryCode: 'PW',
    country: 'Палау'
  },
  {
    phoneCode: '681',
    countryCode: 'WF',
    country: 'Уоллис и Футуна'
  },
  {
    phoneCode: '682',
    countryCode: 'CK',
    country: 'Острова Кука'
  },
  {
    phoneCode: '683',
    countryCode: 'NU',
    country: 'Ниуэ'
  },
  {
    phoneCode: '685',
    countryCode: 'WS',
    country: 'Самоа'
  },
  {
    phoneCode: '686',
    countryCode: 'KI',
    country: 'Кирибати'
  },
  {
    phoneCode: '687',
    countryCode: 'NC',
    country: 'Новая Каледония'
  },
  {
    phoneCode: '688',
    countryCode: 'TV',
    country: 'Тувалу'
  },
  {
    phoneCode: '689',
    countryCode: 'PF',
    country: 'Французская Полинезия'
  },
  {
    phoneCode: '690',
    countryCode: 'TK',
    country: 'Токелау'
  },
  {
    phoneCode: '691',
    countryCode: 'FM',
    country: 'Микронезия'
  },
  {
    phoneCode: '692',
    countryCode: 'MH',
    country: 'Маршалловы Острова'
  },
  {
    phoneCode: '7',
    countryCode: 'KZ',
    country: 'Казахстан'
  },
  {
    phoneCode: '7',
    countryCode: 'RU',
    country: 'Россия'
  },
  {
    phoneCode: '81',
    countryCode: 'JP',
    country: 'Япония'
  },
  {
    phoneCode: '82',
    countryCode: 'KR',
    country: 'Южная Корея'
  },
  {
    phoneCode: '84',
    countryCode: 'VN',
    country: 'Вьетнам'
  },
  {
    phoneCode: '850',
    countryCode: 'KP',
    country: 'Северная Корея'
  },
  {
    phoneCode: '852',
    countryCode: 'HK',
    country: 'Гонконг'
  },
  {
    phoneCode: '853',
    countryCode: 'MO',
    country: 'Макао'
  },
  {
    phoneCode: '855',
    countryCode: 'KH',
    country: 'Камбоджа'
  },
  {
    phoneCode: '856',
    countryCode: 'LA',
    country: 'Лаос'
  },
  {
    phoneCode: '86',
    countryCode: 'CN',
    country: 'Китай'
  },
  {
    phoneCode: '880',
    countryCode: 'BD',
    country: 'Бангладеш'
  },
  {
    phoneCode: '886',
    countryCode: 'TW',
    country: 'Тайвань'
  },
  {
    phoneCode: '90',
    countryCode: 'TR',
    country: 'Турция'
  },
  {
    phoneCode: '91',
    countryCode: 'IN',
    country: 'Индия'
  },
  {
    phoneCode: '92',
    countryCode: 'PK',
    country: 'Пакистан'
  },
  {
    phoneCode: '93',
    countryCode: 'AF',
    country: 'Афганистан'
  },
  {
    phoneCode: '94',
    countryCode: 'LK',
    country: 'Шри-Ланка'
  },
  {
    phoneCode: '95',
    countryCode: 'MM',
    country: 'Мьянма'
  },
  {
    phoneCode: '960',
    countryCode: 'MV',
    country: 'Мальдивы'
  },
  {
    phoneCode: '961',
    countryCode: 'LB',
    country: 'Ливан'
  },
  {
    phoneCode: '962',
    countryCode: 'JO',
    country: 'Иордания'
  },
  {
    phoneCode: '963',
    countryCode: 'SY',
    country: 'Сирия'
  },
  {
    phoneCode: '964',
    countryCode: 'IQ',
    country: 'Ирак'
  },
  {
    phoneCode: '965',
    countryCode: 'KW',
    country: 'Кувейт'
  },
  {
    phoneCode: '966',
    countryCode: 'SA',
    country: 'Саудовская Аравия'
  },
  {
    phoneCode: '967',
    countryCode: 'YE',
    country: 'Йемен'
  },
  {
    phoneCode: '968',
    countryCode: 'OM',
    country: 'Оман'
  },
  {
    phoneCode: '970',
    countryCode: 'PS',
    country: 'Палестина'
  },
  {
    phoneCode: '971',
    countryCode: 'AE',
    country: 'ОАЭ'
  },
  {
    phoneCode: '972',
    countryCode: 'IL',
    country: 'Израиль'
  },
  {
    phoneCode: '973',
    countryCode: 'BH',
    country: 'Бахрейн'
  },
  {
    phoneCode: '974',
    countryCode: 'QA',
    country: 'Катар'
  },
  {
    phoneCode: '975',
    countryCode: 'BT',
    country: 'Бутан'
  },
  {
    phoneCode: '976',
    countryCode: 'MN',
    country: 'Монголия'
  },
  {
    phoneCode: '977',
    countryCode: 'NP',
    country: 'Непал'
  },
  {
    phoneCode: '98',
    countryCode: 'IR',
    country: 'Иран'
  },
  {
    phoneCode: '992',
    countryCode: 'TJ',
    country: 'Таджикистан'
  },
  {
    phoneCode: '993',
    countryCode: 'TM',
    country: 'Туркменистан'
  },
  {
    phoneCode: '994',
    countryCode: 'AZ',
    country: 'Азербайджан'
  },
  {
    phoneCode: '995',
    countryCode: 'GE',
    country: 'Грузия'
  },
  {
    phoneCode: '996',
    countryCode: 'KG',
    country: 'Киргизия'
  },
  {
    phoneCode: '998',
    countryCode: 'UZ',
    country: 'Узбекистан'
  }
];
